<template lang="pug" src="./sections-new-patients.pug"></template>

<script>
import { globalWaypointTrigger } from '@/mixins'
import appointmentForm from 'components/forms/appointment-form/appointment-form'

export default {
  props: ['props'],
  mixins: [ globalWaypointTrigger ],
  components: {
    appointmentForm
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sections/sections-new-patients/sections-new-patients.vue